import axios from "axios";
import { ecommerceServer } from "../../server";
import { getStoredCurrentProfile } from "../../utils/shopProfile";

// get all orders of user
export const getAllOrdersOfUser = (userId) => async (dispatch) => {
  try {
    dispatch({
      type: "getAllOrdersUserRequest",
    });

    const { data } = await axios.get(
      `${ecommerceServer}/order/get-all-orders/${userId}`
    );

    dispatch({
      type: "getAllOrdersUserSuccess",
      payload: data.orders,
    });
  } catch (error) {
    dispatch({
      type: "getAllOrdersUserFailed",
      payload: error.response.data.message,
    });
  }
};


// get all orders of seller
export const getAllOrdersOfShop = (shopId) => async (dispatch) => {
  try {
    dispatch({
      type: "getAllOrdersShopRequest",
    });

    const { data } = await axios.get(
      `${ecommerceServer}/order/get-seller-all-orders/${shopId}`
    );

    dispatch({
      type: "getAllOrdersShopSuccess",
      payload: data.orders,
    });
  } catch (error) {
    dispatch({
      type: "getAllOrdersShopFailed",
      payload: error.response.data.message,
    });
  }
};

export const getAllPurchasesOfShop = (shopId) => async (dispatch) => {
  try {
    dispatch({
      type: "getAllPurchasesShopRequest",
    });

    const { data } = await axios.get(
      `${ecommerceServer}/order/get-seller-purchases/${shopId}`
    );

    dispatch({
      type: "getAllPurchasesShopSuccess",
      payload: data.orders,
    });
  } catch (error) {
    dispatch({
      type: "getAllPurchasesShopFailed",
      payload: error.response ? error.response.data.message : "Could not connect to the server",
    });
  }
};

// get all orders of Admin
export const getAllOrdersOfAdmin = () => async (dispatch) => {
  try {
    dispatch({
      type: "adminAllOrdersRequest",
    });

    const currentProfile = getStoredCurrentProfile() || "User";

    const { data } = await axios.get(`${ecommerceServer}/order/admin-all-orders`, {
      withCredentials: true,
      headers: {
        "current-profile": currentProfile,
      },
    });

    dispatch({
      type: "adminAllOrdersSuccess",
      payload: data.orders,
    });
  } catch (error) {
    dispatch({
      type: "adminAllOrdersFailed",
      payload: error?.response?.data?.message || error?.message || "Unable to load admin orders",
    });
  }
};
